"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Methodology() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="15316" id="how-infrapm-works" className="bg-background text-foreground font-default ![padding:128px_0px_96px_0px]">
      <div className="mx-auto max-w-[1376px] px-5 md:px-8">
        <div ref={headerRef} className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-x-12 items-center">
          <div className="md:col-span-7">
            <h2 className="mt-6 text-foreground font-medium leading-[1.02] tracking-[-0.018em] transition-all duration-700 ease-out !text-[70px]" style={{
            fontSize: "clamp(2rem, 3.8vw, 3.5rem)",
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? "translateY(0)" : "translateY(16px)",
            transitionDelay: "100ms"
          }}>
              About InfraPM
            </h2>

            <div className="mt-8 max-w-[760px] transition-all duration-700 ease-out" style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? "translateY(0)" : "translateY(16px)",
            transitionDelay: "180ms"
          }}>
              <p className="text-left text-[1.25rem] leading-[1.55] text-muted-foreground">InfraPM helps utilities and local governments identify, pursue, and manage public funding for critical infrastructure projects. InfraPM staff have 15+ years of experience in the public sector, including grant writing and administration, managing federal and state agency interactions, and translating community needs into funding and project implementation. <br /><br />InfraPM provides independent infrastructure strategy support grounded in public information, client-provided materials, and original analysis. We are careful to accept work only where our role is clear and additive. We do not take on scopes that would place us on competing sides of the same matter or dilute the quality, independence, or value of our support to a client.</p>

              

              
            </div>
          </div>

          <div className="md:col-span-5 transition-all duration-700 ease-out" style={{
          opacity: headerVisible ? 1 : 0,
          transform: headerVisible ? "translateY(0)" : "translateY(16px)",
          transitionDelay: "240ms"
        }}>
            <div className="group aspect-[4/3] overflow-hidden rounded-lg">
              <img src="https://infrapm.com/wp-content/uploads/2026/07/20260323_1615433-scaled.jpg" alt="Infrastructure planning and coordination" className="h-full w-full object-cover grayscale transition-all duration-500 ease-out group-hover:grayscale-0 group-hover:scale-105" loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}